const variableRegex = /{([\w]*)}/g;

function evalExpression (expression) {
  // eslint-disable-next-line no-eval
  return String(eval(expression));
}

function replaceVariables (template, argumentsValues) {
  if (typeof template !== 'string') {
    return template;
  }
  let rv = template.replace(variableRegex, (matched, argumentName) => {
    let argumentValue = argumentsValues[argumentName];
    if (argumentValue && argumentValue.constructor === Object) {
      argumentValue = JSON.stringify(argumentValue);
    } else if (Array.isArray(argumentValue)) {
      if (argumentValue[0] && argumentValue[0].constructor === Object) {
        argumentValue = `[${argumentValue.map(el => JSON.stringify(el))}]`;
      }
    }
    return argumentValue === undefined ? matched : argumentValue;
  });

  if (rv === 'false') {
    rv = false;
  } else if (rv === 'true') {
    rv = true;
  }
  return rv;
}

function calculateComputed (computed, argumentsValues) {
  const argumentsAndComputedValues = {...argumentsValues};
  const computedValues = {};
  for (const computedVariable of computed) {
    const calc = computedVariable.js_calc || computedVariable.calc;
    const expression = replaceVariables(calc, argumentsAndComputedValues);
    let value = evalExpression(expression);
    if (value === 'false') {
      value = false;
    } else if (value === 'true') {
      value = true;
    }
    computedValues[computedVariable.id] = value;

    // update context dict for dependencies resolve
    argumentsAndComputedValues[computedVariable.id] = value;
  }
  return computedValues;
}

function compileObjectWithWasTemplated (object, argumentsValues) {
  const compiledObject = {};
  for (const key of Object.keys(object)) {
    const possiblyTemplatedValue = object[key];
    const compiledValue = replaceVariables(possiblyTemplatedValue, argumentsValues);
    const wasTemplated = compiledValue !== possiblyTemplatedValue;
    compiledObject[key] = {value: compiledValue, wasTemplated};
  }
  return compiledObject;
}

function compileObjectFromKeyArray (object = {}, argumentsValues = []) {
  let compiledObject = {};
  const objectIncludesKeys = Object.keys(object).filter(key => argumentsValues.includes(key));

  for (let key of objectIncludesKeys) {
    compiledObject[key] = object[key];
  }

  return compiledObject;
}

function compileArray (array, argumentsValues) {
  // eslint-disable-next-line no-use-before-define
  return array.map(value => compileVariable(value, argumentsValues));
}

function compileObject (object, argumentsValues) {
  const compiledObject = {};
  for (const key of Object.keys(object)) {
    // eslint-disable-next-line no-use-before-define
    compiledObject[key] = compileVariable(object[key], argumentsValues);
  }
  return compiledObject;
}

function compileVariable (variable, argumentsValues) {
  if (Array.isArray(variable)) {
    return compileArray(variable, argumentsValues);

    // typeof null === 'object' -> true
  } else if (variable !== null && typeof variable === 'object') {
    return compileObject(variable, argumentsValues);
  }
  return replaceVariables(variable, argumentsValues);
}

export {
  replaceVariables,
  evalExpression,
  calculateComputed,
  compileObjectWithWasTemplated,
  compileVariable,
  compileObjectFromKeyArray
};
